import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/build/repo/src/components/MDXPageLayout.js";
import PageBanner from '../../components/PageBanner';
import HackavizPreviousEditions from '../../components/HackavizPreviousEditions';
import Button from '../../components/Button';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



<PageBanner styleId={4} title={"Hackaviz"} description={"Prêt, partez, visualisez !"} mdxType="PageBanner" />
<section id="one">
<div className="inner">
</div>
</section>
<HackavizPreviousEditions mdxType="HackavizPreviousEditions" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      